<!-- src/app/views/persona/dialog-form-persona/dialog-form-persona.component.html -->
<div class="dialog-container">
  <app-button-close-dialog></app-button-close-dialog>
  <h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
      accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
      ? 'Ver' : 'Modificar' }} Persona</strong></h2>

  <!-- Spinners para diferentes operaciones -->
  <ngx-spinner [zIndex]="100" name="spPersona" bdColor="rgba(255,255,255,0.8)" size="default"
    color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <ngx-spinner [zIndex]="100" name="spPersonas" bdColor="rgba(255,255,255,0.8)" size="default"
    color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

    <form [formGroup]="form" *ngIf="form">
      <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
        <div class="delete-confirmation">
          <mat-icon class="warning-icon">warning</mat-icon>
          <p>¿Está seguro que desea eliminar a <strong>{{data.item?.nombre}} {{data.item?.apellido}}</strong>?</p>
          <p class="delete-warning">Esta acción no se puede deshacer.</p>
        </div>
      </ng-container>

      <ng-template #formTemplate>
        <mat-tab-group class="form-tabs" animationDuration="300ms">

          <!-- Tab 1: Información Personal -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">person</mat-icon>
              Información Personal
            </ng-template>

            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>title</mat-icon>
                </div>
                <mat-card-title>Datos Principales</mat-card-title>
                <mat-card-subtitle>Información esencial del acceso rápido</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>

                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Nombre</mat-label>
                      <input placeholder="Nombre de la persona" type="text" formControlName="Nombre"
                        style="text-transform: capitalize" matInput maxlength="150" />
                      <mat-error *ngIf="f.Nombre.errors?.['required']">Este campo es
                        <strong>requerido</strong>.</mat-error>
                      <mat-error *ngIf="f.Nombre.errors?.['maxlength']">Máximo 150 caracteres.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Apellido</mat-label>
                      <input placeholder="Apellido de la persona" type="text" formControlName="Apellido"
                        style="text-transform: capitalize" matInput maxlength="150" />
                      <mat-error *ngIf="f.Apellido.errors?.['maxlength']">Máximo 150 caracteres.</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <ngx-spinner [zIndex]="-1" name="spTiposDocumento" bdColor="rgba(255,255,255,0.8)" size="small"
                        color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                      <mat-label>Tipo de Documento</mat-label>
                      <mat-select placeholder="Seleccione un tipo" formControlName="TiposDocumento"
                        (selectionChange)="selectTipoDocumento($event)">
                        <mat-option [value]="tipoDocumento.id"
                          *ngFor="let tipoDocumento of lstTipoDocumentoDto; let i = index; trackBy: trackByItems">
                          {{ tipoDocumento.descripcion }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Número de Documento</mat-label>
                      <input placeholder="Número de documento" type="text" formControlName="NroDocumento" matInput
                        maxlength="50" oninput="this.value=this.value.toUpperCase()" />
                      <mat-error *ngIf="f.NroDocumento.errors?.['maxlength']">Máximo 50 caracteres.</mat-error>
                      <mat-error *ngIf="f.NroDocumento.errors?.['pattern']">Caracteres inválidos.</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Sexo</mat-label>
                      <mat-select placeholder="Seleccione sexo" formControlName="Sexo">
                        <mat-option value="M">Masculino</mat-option>
                        <mat-option value="F">Femenino</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fecha de Nacimiento</mat-label>
                      <input matInput [matDatepicker]="pickerNacimiento" formControlName="FechaNacimiento"
                        placeholder="Seleccione fecha">
                      <mat-datepicker-toggle matSuffix [for]="pickerNacimiento"></mat-datepicker-toggle>
                      <mat-datepicker #pickerNacimiento></mat-datepicker>
                      <mat-hint>DD/MM/YYYY</mat-hint>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                      <ngx-spinner [zIndex]="-1" name="spEstadosCivil" bdColor="rgba(255,255,255,0.8)" size="small"
                        color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                      <mat-label>Estado Civil</mat-label>
                      <mat-select placeholder="Seleccione estado civil" formControlName="EstadoCivil">
                        <mat-option [value]="estadoCivil.id"
                          *ngFor="let estadoCivil of lstEstadosCivilModel; let i = index; trackBy: trackByItems">
                          {{ estadoCivil.descripcion }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <ngx-spinner [zIndex]="-1" name="spTiposPersona" bdColor="rgba(255,255,255,0.8)" size="small"
                        color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                      <mat-label>Tipo de Persona</mat-label>
                      <mat-select placeholder="Seleccione tipo de persona" formControlName="TipoPersona">
                        <mat-option [value]="tipoPersona.id"
                          *ngFor="let tipoPersona of lstTiposPersona; let i = index; trackBy: trackByItems">
                          {{ tipoPersona.descripcion }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="f.TipoPersona.errors?.['required']">Este campo es
                        <strong>requerido</strong>.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Ocupación</mat-label>
                      <input placeholder="Ocupación o profesión" type="text" formControlName="Ocupacion" matInput
                        maxlength="50" />
                      <mat-error *ngIf="f.Ocupacion.errors?.['maxlength']">Máximo 50 caracteres.</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 col-md-8">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Observaciones</mat-label>
                      <textarea placeholder="Observaciones adicionales" formControlName="Observacion" matInput rows="3"
                        maxlength="2000"></textarea>
                      <mat-error *ngIf="f.Observacion.errors?.['maxlength']">Máximo 2000 caracteres.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-4">
                    <mat-slide-toggle formControlName="Activo" color="primary" class="w-100">
                      <span class="toggle-label">Activo</span>
                    </mat-slide-toggle>
                    <p class="form-hint">Estado de la persona en el sistema</p>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-tab>

          <!-- Tab 2: Contacto -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">contact_phone</mat-icon>
              Contacto
            </ng-template>

            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>email</mat-icon>
                </div>
                <mat-card-title>Información de Contacto</mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Correo Electrónico</mat-label>
                      <input placeholder="correo@ejemplo.com" type="email" formControlName="Correo" matInput />
                      <mat-error *ngIf="f.Correo.errors?.['required']">Este campo es
                        <strong>requerido</strong>.</mat-error>
                      <mat-error *ngIf="f.Correo.errors?.['email']">Formato de correo inválido.</mat-error>
                      <mat-error *ngIf="f.Correo.errors?.['maxlength']">Máximo 50 caracteres.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Teléfono Principal</mat-label>
                      <input placeholder="Teléfono de contacto principal" type="tel" formControlName="TelefonoPrincipal"
                        matInput maxlength="30" />
                      <mat-error *ngIf="f.TelefonoPrincipal.errors?.['required']">Este campo es
                        <strong>requerido</strong>.</mat-error>
                      <mat-error *ngIf="f.TelefonoPrincipal.errors?.['maxlength']">Máximo 30 caracteres.</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Teléfono Alternativo</mat-label>
                      <input placeholder="Teléfono alternativo" type="tel" formControlName="TelefonoAlternativo"
                        matInput maxlength="30" />
                      <mat-error *ngIf="f.TelefonoAlternativo.errors?.['maxlength']">Máximo 30 caracteres.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Teléfono Laboral</mat-label>
                      <input placeholder="Teléfono del trabajo" type="tel" formControlName="TelefonoLaboral" matInput
                        maxlength="30" />
                      <mat-error *ngIf="f.TelefonoLaboral.errors?.['maxlength']">Máximo 30 caracteres.</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>location_on</mat-icon>
                </div>
                <mat-card-title>Información de Direcciones</mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Ubicación Personal</mat-label>
                      <input placeholder="Dirección de domicilio" type="text" formControlName="Ubicacion"
                        style="text-transform: capitalize" matInput maxlength="200" />
                      <mat-error *ngIf="f.Ubicacion.errors?.['maxlength']">Máximo 200 caracteres.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Ubicación Laboral</mat-label>
                      <input placeholder="Dirección del trabajo" type="text" formControlName="UbicacionLaboral" matInput
                        maxlength="150" />
                      <mat-error *ngIf="f.UbicacionLaboral.errors?.['maxlength']">Máximo 150 caracteres.</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Código Postal</mat-label>
                      <input placeholder="Código postal" type="text" formControlName="CodigoPostal" matInput
                        maxlength="8" />
                      <mat-error *ngIf="f.CodigoPostal.errors?.['maxlength']">Máximo 8 caracteres.</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-tab>

          <!-- Tab 3: Ubicación Geográfica -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">public</mat-icon>
              Ubicación Geográfica
            </ng-template>

            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>map</mat-icon>
                </div>
                <mat-card-title>Datos Geográficos</mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <app-buscar-pais-georef (paisSeleccionado)="paisSeleccionado($event)"
                      [name]="this.data?.item?.pais?.descripcion">
                    </app-buscar-pais-georef>
                  </div>

                  <div class="col-sm-12 col-md-6">
                    <app-selector-localidad-provincia [idLocalidadActual]="personaDetailDto?.idLocalidad"
                      (localidadSeleccionada)="seleccionaLocalidad($event)">
                    </app-selector-localidad-provincia>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

          </mat-tab>

        </mat-tab-group>
      </ng-template>
    </form>

  </mat-dialog-content>

  <!-- Vista de solo lectura -->
  <mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">
    <div *ngIf="personaDetailDto" class="view-content">
      <mat-tab-group class="view-tabs">

        <!-- Tab 1: Información Personal -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">person</mat-icon>
            Información Personal
          </ng-template>

          <div class="tab-content">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <mat-card appearance="outlined" >
                  <mat-card-header>
                    <mat-card-title>Datos de Identidad</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Estado:</span>
                      <span class="property-value">
                        <app-status-badge [estado]="personaDetailDto.activo"></app-status-badge>
                      </span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Nombre completo:</span>
                      <span class="property-value">{{ personaDetailDto?.nombre }} {{ personaDetailDto?.apellido
                        }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Documento:</span>
                      <span class="property-value">
                        {{ personaDetailDto?.tipoDocumento?.descripcion }} {{ personaDetailDto?.nroDocumento }}
                      </span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Sexo:</span>
                      <span class="property-value">{{ personaDetailDto?.sexo === 'M' ? 'Masculino' :
                        personaDetailDto?.sexo === 'F' ? 'Femenino' : 'No especificado' }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Fecha de Nacimiento:</span>
                      <span class="property-value">{{ personaDetailDto?.fechaNacimiento | date:'dd/MM/yyyy' }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>

              <div class="col-sm-12 col-md-6">
                <mat-card appearance="outlined" >
                  <mat-card-header>
                    <mat-card-title>Información Adicional</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Estado Civil:</span>
                      <span class="property-value">{{ personaDetailDto?.estadoCivil?.descripcion || 'No especificado'
                        }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Tipo de Persona:</span>
                      <span class="property-value">{{ personaDetailDto?.tipoPersona?.descripcion || 'No especificado'
                        }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Ocupación:</span>
                      <span class="property-value">{{ personaDetailDto?.ocupacion || 'No especificada' }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

            <div class="row" *ngIf="personaDetailDto?.observacion">
              <div class="col-sm-12">
                <mat-card appearance="outlined" >
                  <mat-card-header>
                    <mat-card-title>Observaciones</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-value">{{ personaDetailDto?.observacion }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 2: Contacto -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">contact_phone</mat-icon>
            Contacto
          </ng-template>

          <div class="tab-content">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <mat-card appearance="outlined" >
                  <mat-card-header>
                    <mat-card-title>Información de Contacto</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Correo:</span>
                      <span class="property-value">{{ personaDetailDto?.correo || 'No especificado' }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Teléfono Principal:</span>
                      <span class="property-value">{{ personaDetailDto?.telefonoPrincipal || 'No especificado' }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Teléfono Alternativo:</span>
                      <span class="property-value">{{ personaDetailDto?.telefonoAlternativo || 'No especificado'
                        }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Teléfono Laboral:</span>
                      <span class="property-value">{{ personaDetailDto?.telefonoLaboral || 'No especificado' }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>

              <div class="col-sm-12 col-md-6">
                <mat-card appearance="outlined" >
                  <mat-card-header>
                    <mat-card-title>Direcciones</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Ubicación Personal:</span>
                      <span class="property-value">{{ personaDetailDto?.ubicacion || 'No especificada' }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Ubicación Laboral:</span>
                      <span class="property-value">{{ personaDetailDto?.ubicacionLaboral || 'No especificada' }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Código Postal:</span>
                      <span class="property-value">{{ personaDetailDto?.codigoCpa || 'No especificado' }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 3: Ubicación Geográfica -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">public</mat-icon>
            Ubicación Geográfica
          </ng-template>

          <div class="tab-content">
            <div class="row">
              <div class="col-sm-12">
                <mat-card appearance="outlined" >
                  <mat-card-header>
                    <mat-card-title>Datos Geográficos</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">País:</span>
                      <span class="property-value">{{ personaDetailDto?.pais?.descripcion || 'No especificado' }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Provincia:</span>
                      <span class="property-value">{{ personaDetailDto?.localidad?.provincia?.descripcion || 'No
                        especificada' }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Localidad:</span>
                      <span class="property-value">{{ personaDetailDto?.localidad?.descripcion || 'No especificada'
                        }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button-cancel-dialog></app-button-cancel-dialog>

    <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form?.valid" (click)="agregar()">
    </app-button-add>

    <app-button-save *ngIf="data.accion == accionesDialog.Modificar" [disabled]="!form?.valid" [isDialogClose]="true"
      (saveClicked)="modificar()" (cancelClicked)="closeDialog()">
    </app-button-save>

    <app-button-delete *ngIf="data.accion == accionesDialog.Eliminar" (click)="eliminar()"
      (cancelClicked)="closeDialog()" [isDialogClose]="true">
    </app-button-delete>
  </mat-dialog-actions>
</div>
